<template>
  <div class="video-player__wrapper">
    <video
      v-if="videoSrc"
      :id="videoCode"
      ref="reference"
      style="width: 100%; height: 100%"
      class="video-player__innner"
      loop
      preload="meta"
      muted
      webkit-playsinline="true"
      playsInline="true"
      controls="controls"
      :data-play-status="isPlaying"
      @playing="onPlay"
      @pause="onPause"
      @ended="onEnd"
    >
      <source :src="videoSrc" />
    </video>
    <div v-else class="video-play__cover" style="width: 100%; height: 100%" @click="onClick">
      <img
        v-if="captureImg"
        class="video-play__btn"
        src="@/assets/ua-icon24/icon-play.svg"
        alt="play"
      />
      <img v-if="captureImg" class="video-play__placeholder" :src="captureImg" alt="视频截图" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoPlayer',
  props: {
    captureImg: {
      type: String,
      required: true
    },
    videoSrc: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showVideo: false,
      isPlaying: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.onClick();
    });
  },
  methods: {
    async onClick() {
      await this.$nextTick();
      this.$refs.reference?.play();
    },
    onPlay() {
      // 当播放的时候暂停其他播放器
      const videos = document.querySelectorAll('.video-player__innner');
      Array.from(videos).forEach(el => {
        const status = el.getAttribute('data-play-status');
        if (status === 'true') {
          el.pause();
        }
      });
      this.isPlaying = true;
    },
    onPause() {
      this.isPlaying = false;
    },
    onEnd() {
      this.isPlaying = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.video-player__wrapper {
  width: 280px;
  height: 100px;
  position: relative;
}
.video-play__btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  user-select: none;
  border-radius: 50%;
  box-shadow: 2px 2px 4px rgba(#000000, 0.2);
  width: 48px;
}

.video-play__cover {
  cursor: pointer;
}
.video-play__placeholder {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
